import axios from 'axios';

export const BASE_URL    = process.env.REACT_APP_BASE_URL;
export const COMBO_URL   = process.env.REACT_APP_COMBO_URL;
export const ImageUrl    = process.env.REACT_APP_IMAGE_URL;
export const reportsUrl  = process.env.REACT_APP_REPORTS_URL;
export const myUrl       = process.env.REACT_APP_MY_URL;

const getToken = () => localStorage.getItem('UserDetailToken');

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
});

// Attach token on every request so it stays fresh after login
userRequest.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.token = `Bearer ${token}`;
  return config;
});
